<template>
  <div class="nav-mobile" @scroll="handleScroll">
    <router-link :to="path" class="holder-logo">
      <div class="logo" id="logo-mob">
        <img src="../../../assets/imgs/vivinho_branco.png" alt style="height: 50px;" />
      </div>
    </router-link>
    <NavegacaoMobile />
    <transition name="fade">
      <div class="fundo-scroll" v-if="scrolled"></div>
      <!-- <div class="fundo-scroll" :style="scrolled === true ? 'opacity: 100' : 'opacity: 0'"></div> -->
    </transition>
  </div>
</template>

<script>
import NavegacaoMobile from '@/components/layout/header/NavegacaoMobile.vue';
export default {
  name: 'NavMainMobile',
  props: {
    path: {
      type: [String, Object],
      default: () => ({
        name: 'home',
      }),
      required: true,
    },
  },
  components: {
    NavegacaoMobile,
  },
  data: () => ({
    scrolled: false,
  }),
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 40;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.nav-mobile {
  display: none;
}

.fundo-scroll {
  @extend %gradiente_twilight;
  width: 100%;
  height: 85px;
  opacity: 0.99;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

@media all and (min-width: 300px) and (max-width: 1160px) {
  .nav-mobile {
    display: inline-flex;
    padding: 15px 0px;
    width: 100%;
    justify-content: space-between;
    .holder-logo {
      z-index: 10000;
    }
    .logo img {
      z-index: 50000;
      margin-left: 20px;
      width: 174px;
    }
  }

  .fundo-scroll {
    max-height: 75px;
  }
}

@media all and (min-width: 680px) and (max-width: 1160px) {
  .nav-mobile {
    display: inline-flex;
    padding: 15px 0px;
    width: 100%;
    justify-content: space-between;
    .holder-logo {
      z-index: 10000;
    }
    .logo img {
      margin-left: 40px;
      width: 280px;
    }
  }

  .fundo-scroll {
    max-height: 100px;
  }
}
</style>
